import HGWSymbol from "./HGWSymbol";

/**
 * BrandEyebrow — reusable "eyebrow" chip with the HGW symbol.
 * Standardises the visual identity across sections without extra imports.
 *
 * Props:
 *   - children: eyebrow text
 *   - align: "center" | "left" (default "center")
 *   - tone: "light" (blue on grey pill, default) | "dark" (white on black pill, use over dark bg)
 *   - className: extra utility classes
 */
export default function BrandEyebrow({ children, align = "center", tone = "light", className = "" }) {
  const wrapAlign =
    align === "left"
      ? "flex justify-start"
      : "flex justify-center";
  const pillStyle =
    tone === "dark"
      ? "bg-white/10 text-white"
      : "bg-[#0d1b2a]/5 text-[#1D3F94]";
  const symbolColor = tone === "dark" ? "text-white" : "text-[#1D3F94]";
  return (
    <div className={`${wrapAlign} ${className}`}>
      <div className={`inline-flex items-center gap-2.5 px-3 py-1.5 rounded-full ${pillStyle}`}>
        <HGWSymbol size={13} className={symbolColor} />
        <span className="text-[11px] md:text-[12px] uppercase tracking-widest font-medium">
          {children}
        </span>
      </div>
    </div>
  );
}
